import React, { useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import AppColors from "@mywvglobal-shared/mywv-shared/common/appColors";
import AppStyles from "../../config/styles";
import IMAGEPICKERICON from "../../images/attach_img_icon.svg";
import IMAGEPICKERICONMOBILE from "../../images/attach_img_icon_mobile.svg";
import { AddChildCloseIcon, ImgSeparator } from "../atoms/ConnectStories";
import { gaEvent } from "../../utilities/analytics";
import { useSelector } from "react-redux";
import "../../styles/ConnectScreen.css";
import { isMobile } from "../../utilities/deviceUtilities";

const styles = {
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex !important", /* Enables flexbox */
    justifyContent: "center", /* Centers horizontally */
    alignItems: "center", /* Centers vertically */
  },
  modalcointainer: {
    paddingLeft: "5%",
  },
  viewstyle: {
    borderTopRightRadius: "12px",
    borderTopLeftRadius: "12px",
    backgroundColor: "white",
  },
  scrollViewstyle: {
    width: "100%",
  },
  viewLine: {
    alignSelf: "center",
    backgroundColor: AppStyles.colors.COLOR_GREYE6,
    marginTop: "6px",
    height: "4px",
    width: "96px",
  },
  viewBulletPoints: {
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "20px",
    flexDirection: "row",
    width: "100%",
    display: "flex",
  },
  viewCircle: {
    marginTop: "6px",
    alignSelf: "flex-start",
    borderRadius: "4px",
    backgroundColor: "rgba(255, 107, 0, 1)",
    height: "8px",
    width: "8px",
  },
  iconstyle: {
    display: "flex",
    margin: "0 auto",
    alignSelf: "center",
  },
  titlestyle: {
    width: "90%",
    textAlign: "center",
    fontFamily: "Lato",
    fontSize: "24px",
    color: "black",
    marginTop: "15px",
    marginLeft: "20px",
    left: "15px",
    right: "30px",
  },
  desstyle: {
    fontFamily: "Lato",
    textAlign: "left",
    fontSize: "18px",
    marginLeft: "30px",
    marginRight: "40px",
    color: "black",
    marginTop: "20px",
    alignSelf: "center",
  },
  desstyleMobile: {
    fontFamily: "Lato-bold",
    textAlign: "center",
    fontSize: "18px",
    color: "black",
    alignSelf: "center",
  },
  desLeftStyle: {
    fontFamily: "Lato",
    textAlign: "left",
    fontSize: "18px",
    marginLeft: "40px",
    marginRight: "40px",
    color: "black",
    marginTop: "20px",
  },
  desBulletPoints: {
    flex: 1,
    fontFamily: "Lato",
    fontSize: "18px",
    marginLeft: "12px",
    marginRight: "40px",
    color: "black",
    textAlign: "left",
    alignSelf: "flex-start",
  },
  photoTouchableOpacityContainer: {
    width: "40%",
    backgroundColor: "rgba(246, 103, 0, 1)",
    borderColor: AppColors.ORANGE_DARK,
    margin: "20px 0px",
    borderRadius: "8px",
    marginLeft: "50%",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transform: "translateX(-53%)",
    padding: "2%",
    boxShadow: "rgb(199, 83, 0) 0px 3px 0px",
  },
  photoButtonText: {
    color: "white",
    marginLeft: "10px",
    marginRight: "10px",
    fontSize: "18px",
    fontFamily: "Lato-Bold",
    cursor: "pointer",
  },
  mobilebackground: {
    backgroundColor: "#F7F6F5",
    borderRadius: "12px",
    boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.2)",
    padding: "20px 10px",
    marginTop: "30px",
    marginRight: "20px",
  }
};

export function AttachPhotoWarningModal(props) {
  const { t } = useTranslation();
  const modalRef = useRef();
  const handleUpload = (e) => {
    props?.onUnderstandClick(e.target.files[0]);
    props?.onClose();
    gaEvent("AttachImagePopupUnderstandBtn", persistItemsReducer);
  };
  const { persistItemsReducer } = useSelector((state) => state);

  useEffect(() => {
    window.addEventListener("focus", focusHanlder);
    window.addEventListener("cancel", () => {
      props?.onClose();
    });
    return () => {
      window.removeEventListener("focus", focusHanlder);
    };
  }, []);

  const focusHanlder = () => {
    let flag = modalRef.current.backdrop?.style?.display || "block";
    if (flag === "none") {
      props?.onClose();
    }
  };

  return (
    <Modal
      show={props?.isVisible}
      onHide={props?.onClose}
      style={styles.modal}
      ref={modalRef}
      className="attach-img vertical-custom-modal"
    >
      <div style={styles.modalcointainer}>
        <AddChildCloseIcon onClick={props?.onClose}>X</AddChildCloseIcon>
        <div>
          <img src={isMobile() ? IMAGEPICKERICONMOBILE : IMAGEPICKERICON} style={styles.iconstyle} alt="" />
          <div>
            <div style={styles.titlestyle}>{t("PleaseNote")}</div>
            {isMobile() ? "" : <ImgSeparator></ImgSeparator>}
            {isMobile() ? "" : <div style={styles.desstyle}>{t("PleaseBe")}</div>}
          </div>
          <div style={isMobile() ? styles.mobilebackground : {}}>
            {isMobile() ? <div style={styles.desstyleMobile}>{t("PleaseBe")}</div> : ""}
            <div style={styles.viewBulletPoints}>
              <div style={styles.viewCircle}></div>
              <span style={styles.desBulletPoints}>{t("EveryoneFully")}</span>
            </div>
            <div style={styles.viewBulletPoints}>
              <div style={styles.viewCircle}></div>
              <span style={styles.desBulletPoints}>{t("NoSilly")}</span>
            </div>
            <div style={styles.viewBulletPoints}>
              <div style={styles.viewCircle}></div>
              <span style={styles.desBulletPoints}>{t("NoAlcohol")}</span>
            </div>
            {persistItemsReducer?.selectedSOData?.soCode === "NZLO" &&
              <div style={styles.viewBulletPoints}>
                <div style={styles.viewCircle}></div>
                <span style={styles.desBulletPoints}>{t("HasPermission")}</span>
              </div>}
            <div style={styles.viewBulletPoints}>
              <div style={styles.viewCircle}></div>
              <span style={styles.desBulletPoints}>{t("MaxSize")}</span>
            </div>
          </div>

          <div
            className="understand-button"
            style={styles?.photoTouchableOpacityContainer}
          >
            <input
              type="file"
              id="files"
              accept="image/jpg, image/jpeg"
              onChange={handleUpload}
            />
            <label htmlFor="files" style={styles?.photoButtonText}>
              {t("IUnderstand")}
            </label>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default AttachPhotoWarningModal;
